import React, { useState, useEffect } from "react";
import ButtonEditar from "../ui/Button/ButtonEditar";
import ButtonExcluir from "../ui/Button/ButtonExcluir";
import { listarClientes, excluirCliente } from "../Services/Cliente/clienteService";
import TabelaRodape from "../ui/TabelaRodape";
import { ToastContainer, toast } from "react-toastify";
import ConfirmDialog from "../ui/exclusao/ConfirmDialog";

export default function TabelaCliente({ onEditar, searchValue = "" }) {
  const [clientes, setClientes] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);
  const [pagina, setPagina] = useState(1);
  const itensPorPagina = 10;
  const [openDialog, setOpenDialog] = useState(false);
  const [clienteExcluir, setClienteExcluir] = useState(null);

  useEffect(() => {
    async function carregarClientes() {
      try {
        setCarregando(true);
        const resposta = await listarClientes();

        if (resposta.status === "sucesso" && Array.isArray(resposta.dados)) {
          setClientes(resposta.dados);
        } else if (Array.isArray(resposta)) {
          setClientes(resposta);
        } else {
          throw new Error("Formato inesperado de resposta do servidor.");
        }
      } catch (erro) {
        console.error("Erro ao carregar clientes:", erro);
        setErro("Não foi possível carregar os clientes.");
      } finally {
        setCarregando(false);
      }
    }

    carregarClientes();
  }, []);

  if (carregando) {
    return (
      <div className="text-center py-8 text-gray-600 text-sm">
        Carregando clientes...
      </div>
    );
  }

  if (erro) {
    return (
      <div className="text-center py-8 text-red-600 text-sm">{erro}</div>
    );
  }

  const tratarNan = (valor) => {
    return valor === "nan" || valor === null || valor === undefined ? "" : valor;
  };

  // 🔍 Filtro de pesquisa (antes da paginação)
  const clientesFiltrados = clientes.filter((cliente) => {
    const termo = searchValue.toLowerCase();
    return (
      (cliente.razaoSocial && cliente.razaoSocial.toLowerCase().includes(termo)) ||
      (cliente.nomeFantasia && cliente.nomeFantasia.toLowerCase().includes(termo)) ||
      (cliente.cpfCnpj && cliente.cpfCnpj.toLowerCase().includes(termo)) ||
      (cliente.cidade && cliente.cidade.toLowerCase().includes(termo)) ||
      (cliente.uf && cliente.uf.toLowerCase().includes(termo))
    );
  });

  const totalPaginas = Math.ceil(clientesFiltrados.length / itensPorPagina);
  const inicio = (pagina - 1) * itensPorPagina;
  const fim = inicio + itensPorPagina;
  const clientesPagina = clientesFiltrados.slice(inicio, fim);

  const mudarPagina = (novaPagina) => {
    if (novaPagina >= 1 && novaPagina <= totalPaginas) {
      setPagina(novaPagina);
    }
  };

  const handleExcluir = (cliente) => {
    setClienteExcluir(cliente);
    setOpenDialog(true);
  };

  const confirmarExclusao = async () => {
    if (!clienteExcluir) return;

    try {
      const resposta = await excluirCliente(clienteExcluir.id);
      if (resposta.status === "sucesso") {
        toast.success("Cliente excluído com sucesso!", {
          position: "top-right",
          autoClose: 2500,
          style: {
            background: "#f9fafb",
            color: "#333",
            border: "1px solid #ddd",
            borderRadius: "0px",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: "14px",
            boxShadow: "none",
            padding: "10px 16px",
          },
          icon: "✅",
        });

        setClientes(clientes.filter((c) => c.id !== clienteExcluir.id));
      } else {
        throw new Error("Erro ao excluir cliente");
      }
    } catch (error) {
      toast.error("Erro ao excluir cliente.", {
        position: "top-right",
        autoClose: 2500,
        style: {
          background: "#f9fafb",
          color: "#333",
          border: "1px solid #fca5a5",
          borderRadius: "0px",
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          fontSize: "14px",
          boxShadow: "none",
          padding: "10px 16px",
        },
        icon: "⚠️",
      });
      console.error(error);
    }

    setOpenDialog(false);
    setClienteExcluir(null);
  };

  const cancelarExclusao = () => {
    setOpenDialog(false);
    setClienteExcluir(null);
  };

  return (
    <div className="overflow-x-auto mt-3 border rounded-lg shadow-sm">
      <ToastContainer />

      <table className="w-full text-left border-collapse">
        <thead style={{ backgroundColor: "#4d4d4d", color: "white", fontFamily: "Roboto, Helvetica, Arial, sans-serif" }}>
          <tr>
            <th className="py-4 px-4 font-medium text-sm">Razão Social</th>
            <th className="py-4 px-4 font-medium text-sm">Nome Fantasia</th>
            <th className="py-4 px-4 font-medium text-sm">CPF/CNPJ</th>
            <th className="py-4 px-4 font-medium text-sm">Telefone</th>
            <th className="py-4 px-4 font-medium text-sm">Cidade</th>
            <th className="py-4 px-4 font-medium text-sm">UF</th>
            <th className="py-4 px-4 font-medium text-sm text-center">Ações</th>
          </tr>
        </thead>

        <tbody>
          {clientesPagina.length > 0 ? (
            clientesPagina.map((cliente, index) => (
              <tr
                key={cliente.id}
                className={`border-b border-gray-200 transition-all hover:bg-[#f95000] hover:text-white ${index % 2 === 0 ? "bg-gray-100" : "bg-white"}`}
              >
                <td className="py-3 px-4 text-sm text-gray-700">{tratarNan(cliente.razaoSocial || cliente.razao_social)}</td>
                <td className="py-3 px-4 text-sm text-gray-700">{tratarNan(cliente.nomeFantasia || cliente.nome_fantasia)}</td>
                <td className="py-3 px-4 text-sm text-gray-700">{tratarNan(cliente.cpfCnpj || cliente.cpf_cnpj || cliente.cnpj || cliente.cpf)}</td>
                <td className="py-3 px-4 text-sm text-gray-700">{tratarNan(cliente.telefone)}</td>
                <td className="py-3 px-4 text-sm text-gray-700">{tratarNan(cliente.cidade)}</td>
                <td className="py-3 px-4 text-sm text-gray-700">{tratarNan(cliente.uf)}</td>
                <td className="py-3 px-4 text-sm">
                  <div className="flex justify-center items-center gap-3">
                    <ButtonEditar onClick={() => onEditar(cliente)} />
                    <ButtonExcluir onClick={() => handleExcluir(cliente)} />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-gray-500 py-6 text-sm italic">
                Nenhum cliente encontrado.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <TabelaRodape
        total={clientesFiltrados.length}
        pagina={pagina}
        itensPorPagina={itensPorPagina}
        onPaginaChange={mudarPagina}
      />

      <ConfirmDialog
        open={openDialog}
        message={`Tem certeza que deseja excluir o cliente: ${clienteExcluir ? clienteExcluir.nomeFantasia : ""}?`}
        onConfirm={confirmarExclusao}
        onCancel={cancelarExclusao}
      />
    </div>
  );
}
